import { useState } from 'react';

import { Button } from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

import { useDisconnectCalendarMutation } from '../../../resources/appointment/mutations';

import { AppointmentDisconnectConfirmDialog } from './AppointmentDisconnectConfirmDialog';

export const AppointmentGoogleConnection = (): JSX.Element => {
    const { formatMessage } = useIntl();
    const { mutate: disconnectCalendar, isPending } = useDisconnectCalendarMutation();
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleConfirm = () => {
        disconnectCalendar('google');
        setIsDialogOpen(false);
    };

    return (
        <>
            <Button
                data-spec-id="agenda-disconnect-google-button"
                color="error"
                onClick={() => setIsDialogOpen(true)}
                disabled={isPending}
            >
                {formatMessage({ id: 'appointment.google_connection.disconnect_button' })}
            </Button>
            <AppointmentDisconnectConfirmDialog
                isOpen={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
                onConfirm={handleConfirm}
            />
        </>
    );
};
